import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  getCountryList({ commit }, params) {
    return new Promise(resolve => {
      axios({
        url: "/country/list",
        params: {
          order_by: 'nice_name',
          order_dir: 'asc',
          per_page: params.per_page ?  params.per_page : 1000,
          nice_name: params.nice_name || ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  getAreaCodeList({ commit }, params) {
    return new Promise(resolve => {
      axios({
        url: "/area_code/list",
        params: {
          order_dir: 'asc',
          per_page: params.per_page || 1000,
          country_uuid: params.countryId || ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
